var UserManageLinkedAccounts = function UserManageLinkedAccounts(_, args, context, info) {
  var userId = args.userId;
  var url = "".concat(context.url.stargateRoot, "/users/").concat(userId, "/manage/linked-accounts");
  return context.fetch(url).then(function (res) {
    return res.json();
  }).then(function (data) {
    return {
      google: Boolean(data && data.google && data.google.linked),
      microsoft: Boolean(data && data.microsoft && data.microsoft.linked),
      apple: Boolean(data && data.apple && data.apple.linked),
      saml: Boolean(data && data.saml && data.saml.linked)
    };
  });
};
export default UserManageLinkedAccounts;